<script setup>
import { defineProps } from 'vue';
import { VueFinalModal } from 'vue-final-modal';

const props = defineProps(['title']);

</script>

<template>
    <VueFinalModal class="flex justify-center items-center z-[99]" content-class="flex flex-col gap-5 sm:gap-6 max-sm:h-full w-full sm:w-124 relative sm:m-4 p-5 sm:p-10 bg-grayscale-900 sm:rounded-lg">
        <h2 class="h2 text-white max-sm:pb-6 max-sm:border-solid max-sm:border-b border-gradient">
            <span class="block text-xs text-grayscale-400 mb-2" v-html="$t('global.langWarning')"></span>
            {{ props.title }}
        </h2>
        <slot />
    </VueFinalModal>
</template>

<style scoped></style>
